import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { fetchSocialNets, upsertSocialNets } from './actions';
import type { SocialNetsSliceState } from './social-nets-store';

type ReducerBuilder = ActionReducerMapBuilder<SocialNetsSliceState>;

export function createFetchSocialNetsReducer(builder: ReducerBuilder) {
  builder.addCase(fetchSocialNets.pending, (state) => {
    state.isLoaded = false;
    state.isLoading = true;
  });

  builder.addCase(fetchSocialNets.fulfilled, (state, action) => {
    state.isLoading = false;
    state.isLoaded = true;
    state.data = action.payload;
  });

  builder.addCase(fetchSocialNets.rejected, (state) => {
    state.isLoading = false;
    state.isLoaded = false;
  });
}

export function createSaveSocialNetsReducer(builder: ReducerBuilder) {
  builder.addCase(upsertSocialNets.pending, (state) => {
    state.isProcessing = true;
    state.process = 'update';
  });

  builder.addCase(upsertSocialNets.fulfilled, (state, action) => {
    state.isProcessing = false;
    state.process = null;

    // Update existing social networks and add new ones
    const updatedData = [...state.data];

    action.payload.forEach((savedSocialNet) => {
      const existingIndex = updatedData.findIndex((sn) => sn.type === savedSocialNet.type);

      if (existingIndex !== -1) {
        // Update existing social network
        updatedData[existingIndex] = savedSocialNet;
      } else {
        // Add new social network
        updatedData.push(savedSocialNet);
      }
    });

    state.data = updatedData;
  });

  builder.addCase(upsertSocialNets.rejected, (state) => {
    state.isProcessing = false;
    state.process = null;
  });
}
